import { Link } from 'react-router';

export function AssetLink({ asset }: { asset: { asset_number: string; name?: string } | null | undefined }) {
  if (!asset) return <>–</>;
  return (
    <Link to={`/assets/${encodeURIComponent(asset.asset_number)}`} className="font-mono font-medium text-brand-700 hover:underline">
      {asset.asset_number}
    </Link>
  );
}
